import React from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import {
  IconClock,
  IconChecklist,
  IconAlertTriangle,
  IconCircleCheck,
} from '@tabler/icons-react';
import { PaymentDashboardKpis } from '../../models/referralModel';

interface Props {
  kpis: PaymentDashboardKpis;
}

const cardStyle: React.CSSProperties = {
  borderRadius: '10px',
  border: '1px solid #e2e8f0',
  boxShadow: '0 2px 6px 0 rgba(0, 0, 0, 0.04)',
  backgroundColor: '#ffffff',
  transition: 'all 0.2s ease',
};

const formatCurrency = (amount?: number | null) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount || 0);
};

const PaymentKpiCards: React.FC<Props> = ({ kpis }) => {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '16px',
        marginBottom: '24px',
      }}
    >
      {/* POR PAGAR */}
      <Card className="h-100 mb-0" style={cardStyle}>
        <CardBody className="py-3 px-3">
          <Row className="align-items-center">
            <div className="col">
              <div
                className="text-uppercase text-muted font-weight-600 mb-1"
                style={{ fontSize: '11px', letterSpacing: '0.5px' }}
              >
                Por Pagar
              </div>
              <div
                className="font-weight-bold text-dark mb-0"
                style={{
                  fontSize: '26px',
                  lineHeight: '1.1',
                  fontVariantNumeric: 'tabular-nums',
                }}
              >
                {formatCurrency(kpis.to_pay_total)}
              </div>
            </div>
            <Col className="col-auto">
              <div
                className="rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  width: '42px',
                  height: '42px',
                  backgroundColor: '#fff7ed',
                  color: '#ea580c',
                }}
              >
                <IconClock size={22} stroke={2} />
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>

      {/* PAGADO TOTAL */}
      <Card className="h-100 mb-0" style={cardStyle}>
        <CardBody className="py-3 px-3">
          <Row className="align-items-center">
            <div className="col">
              <div
                className="text-uppercase text-muted font-weight-600 mb-1"
                style={{ fontSize: '11px', letterSpacing: '0.5px' }}
              >
                Pagado Total
              </div>
              <div
                className="font-weight-bold text-dark mb-0"
                style={{
                  fontSize: '26px',
                  lineHeight: '1.1',
                  fontVariantNumeric: 'tabular-nums',
                }}
              >
                {formatCurrency(kpis.paid_total)}
              </div>
            </div>
            <Col className="col-auto">
              <div
                className="rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  width: '42px',
                  height: '42px',
                  backgroundColor: '#e6f9f3',
                  color: '#00875e',
                }}
              >
                <IconCircleCheck size={22} stroke={2} />
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>

      {/* LISTOS PARA PAGAR */}
      <Card className="h-100 mb-0" style={cardStyle}>
        <CardBody className="py-3 px-3">
          <Row className="align-items-center">
            <div className="col">
              <div
                className="text-uppercase text-muted font-weight-600 mb-1"
                style={{ fontSize: '11px', letterSpacing: '0.5px' }}
              >
                Listos para Pagar
              </div>
              <div
                className="font-weight-bold text-dark mb-0"
                style={{ fontSize: '26px', lineHeight: '1.1' }}
              >
                {kpis.ready_to_pay_count || 0}
              </div>
            </div>
            <Col className="col-auto">
              <div
                className="rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  width: '42px',
                  height: '42px',
                  backgroundColor: '#ede9fe',
                  color: '#5b21b6',
                }}
              >
                <IconChecklist size={22} stroke={2} />
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>

      {/* DATOS INCOMPLETOS */}
      <Card className="h-100 mb-0" style={cardStyle}>
        <CardBody className="py-3 px-3">
          <Row className="align-items-center">
            <div className="col">
              <div
                className="text-uppercase text-muted font-weight-600 mb-1"
                style={{ fontSize: '11px', letterSpacing: '0.5px' }}
              >
                Datos Incompletos
              </div>
              <div
                className="font-weight-bold text-dark mb-0"
                style={{ fontSize: '26px', lineHeight: '1.1' }}
              >
                {kpis.incomplete_data_count || 0}
              </div>
            </div>
            <Col className="col-auto">
              <div
                className="rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  width: '42px',
                  height: '42px',
                  backgroundColor: '#ffedd5',
                  color: '#c2410c',
                }}
              >
                <IconAlertTriangle size={22} stroke={2} />
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </div>
  );
};

export default PaymentKpiCards;
